'use strict';

var principalTypes = {
    USER: 'USER',
    API_CLIENT: 'API_CLIENT',
    SIGNIANT_DEVICE: 'SIGNIANT_DEVICE'
};

module.exports = principalTypes;